/* eslint-disable no-console */
import { redirect } from 'react-router';
import { GetGrUserFromAccessToken } from '../connection/auth';
import blpAuth from '../connection/blp-auth';
import { getProfile, SIGN_IN_HOST, SIGN_IN_PRESENTER } from '../stores/actions/session';
import store from '../stores/main';

// eslint-disable-next-line no-promise-executor-return
const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

const sendProducerDispatch = (token: string) => {
	store.dispatch({
		type: SIGN_IN_HOST,
		promise: new Promise((resolve) => {
			resolve({
				token,
				events_legacy_channels: [],
				events_channels: [],
				gr_channels: [],
				selectedApp: 'events',
			});
		}),
	});
	store.dispatch(getProfile(token, 'events'));
};

const sendPresenterDispatch = (token: string) => {
	store.dispatch({
		type: SIGN_IN_PRESENTER,
		promise: new Promise((resolve) => {
			resolve({
				token,
				app_signed_in_with: 'events',
			});
		}),
	});
};

// user must be signed in to access any routes using this action
// otherwise they will be redirected to the root path `/`
const blAuthLoader = async (): Promise<Response> => {
	try {
		// at this point user SHOULD have a refresh token
		// however if something has gone wrong we can handle this
		// endpoint as a login redirect handler
		await blpAuth.handleAuthRedirect();

		// if user is logged in, get access token and proceed
		if (blpAuth.refreshToken) {
			await blpAuth.refresh();
		} else {
			// user is not logged in, send them to login app
			// will redirect the user to the sign in page then back to this page
			blpAuth.redirectToSignIn({
				redirect_uri: window.location.href,
			});

			// won't get triggered because of the redirect above, but if that fails
			// then will fall back to /producer
			return redirect('/producer');
		}

		// get gr_user from access token
		const profile = await GetGrUserFromAccessToken();
		if (profile) {
			if (profile.isProducer) {
				sendProducerDispatch(profile.token);
			} else {
				sendPresenterDispatch(profile.token);
			}
		}

		// let redux have a chance to update the state, proceed in the next tick
		await sleep(0);
	} catch (e) {
		blpAuth.refreshToken = undefined;
		console.error('GOTO Greenroom login error:', e);
		return redirect('/producer');
	}
	return new Response(null, { status: 200 });
};

export default blAuthLoader;
